"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7018],{

/***/ 97018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sliding_card_grid_component; }
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/default-props.js

var cards = [
    {
        fullParagraph: {
            topic: {
                text: "01"
            },
            title: "Set marketing goals & strategy",
            body: "Work collaboratively with internal and external stakeholders to define high-level goals and strategies."
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/marketing%20solution/3-Marketing_card.png"
    },
    {
        fullParagraph: {
            topic: {
                text: "02"
            },
            title: "Set marketing goals & strategy",
            body: "Work collaboratively with internal and external stakeholders to define high-level goals and strategies."
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/marketing%20solution/4-Marketing_card.png"
    },
    {
        fullParagraph: {
            topic: {
                text: "03"
            },
            title: "Set marketing goals & strategy",
            body: "Work collaboratively with internal and external stakeholders to define high-level goals and strategies."
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/marketing%20solution/2-Marketing_card.png"
    },
    {
        fullParagraph: {
            topic: {
                text: "04"
            },
            title: "Set marketing goals & strategy",
            body: "Work collaboratively with internal and external stakeholders to define high-level goals and strategies."
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/marketing%20solution/5-Marketing_card.png"
    }
];
/* harmony default export */ var default_props = ({
    borderColor: color_consts.UI_BORDER_LIGHT_COLOR_NAME,
    cards: cards
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/prev-carousel-arrow.js



var PrevCarouselArrow = function(param) {
    var isDisabled = param.isDisabled, _color = param.color, color = _color === void 0 ? colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Previous item"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.939341 10.9393C0.353554 11.5251 0.353554 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97918 12.6066 1.3934C12.0208 0.807609 11.0711 0.807609 10.4853 1.3934L0.939341 10.9393ZM23 10.5L2 10.5L2 13.5L23 13.5L23 10.5Z",
                fill: isDisabled ? colors/* default.gainsboro */.Z.gainsboro : color
            })
        ]
    });
};
/* harmony default export */ var prev_carousel_arrow = (PrevCarouselArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/next-carousel-arrow.js



var NextCarouselArrow = function(param) {
    var isDisabled = param.isDisabled, _color = param.color, color = _color === void 0 ? colors/* default */.Z[color_consts.BRAND_WORK_MANAGEMENT_PRIMARY_COLOR] : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "23",
        height: "24",
        viewBox: "0 0 23 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "Next item"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.0607 10.9393C22.6464 11.5251 22.6464 12.4749 22.0607 13.0607L12.5147 22.6066C11.9289 23.1924 10.9792 23.1924 10.3934 22.6066C9.80761 22.0208 9.80761 21.0711 10.3934 20.4853L18.8787 12L10.3934 3.51472C9.80761 2.92893 9.80761 1.97918 10.3934 1.3934C10.9792 0.807609 11.9289 0.807609 12.5147 1.3934L22.0607 10.9393ZM-2.93491e-07 10.5L21 10.5L21 13.5L2.93491e-07 13.5L-2.93491e-07 10.5Z",
                fill: isDisabled ? colors/* default.gainsboro */.Z.gainsboro : color
            })
        ]
    });
};
/* harmony default export */ var next_carousel_arrow = (NextCarouselArrow);

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card-grid-base-component.scss.js




var HEADER_CONTENT_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var FULL_SCREEN_LEFT_PADDING = "24px";
var ARROW_WIDTH = "23px";
var ARROW_MARGIN = "16px";
var StyledSlidingCardGridBaseComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1r2yr9x0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;&.full-carousel-width{max-width:", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px;padding-left:calc(max(min(100vw,", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px) - ", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px,0px) / 2 + ", HEADER_CONTENT_HORIZONTAL_PADDING, ");}&.full-screen{max-width:", vp_sizes/* FULL_HD_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.KI, "px;padding-right:0;padding-left:24px;.carousel-arrow-wrapper{&.next{left:calc(50% - ", FULL_SCREEN_LEFT_PADDING, ");}&.prev{left:calc(50% - ", FULL_SCREEN_LEFT_PADDING, " - ", ARROW_WIDTH, ");}}}.carousel{.slick-slider{.slick-list{.slick-track{display:flex;padding-bottom:80px;padding-top:0;.slick-slide{height:auto;> div:first-child{height:100%;}}.carousel-item{height:100%;.card-grid-link{.grid-paragraph-with-image{cursor:grab;width:fit-content;border-radius:8px;margin-right:24px;min-height:100%;.grid-paragraph-wrapper{display:flex;.full-paragraph{.button-wrapper{min-height:56px;margin-top:0;.button{display:flex;align-items:flex-end;}}}}.grid-image-wrapper{img{border-bottom-left-radius:8px;border-bottom-right-radius:8px;}}}}}}}}}&.disable-hover-effect{cursor:initial;.carousel{.slick-slider{.slick-list{.slick-track{.slick-slide:last-child{.grid-paragraph-with-image{margin-right:0;}}.carousel-item{.card-grid-link{.grid-paragraph-with-image{cursor:initial;}}}}}}}}.carousel .carousel-arrow-wrapper{top:auto;position:absolute;bottom:0;z-index:", z_index/* TOP_LAYER */.nA, ";height:fit-content;width:fit-content;&.next{left:50%;margin-left:", ARROW_MARGIN, ";&::before{content:none;}}&.prev{left:calc(50% - ", ARROW_WIDTH, ");margin-left:-", ARROW_MARGIN, ";&::before{content:none;}}}");

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card/sliding-card-component.scss.js


var StyledSlidingCardComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ed3jp1x0"
})("position:relative;height:100%;.card{top:0;left:0;transition:opacity 0.3s ease-in-out;height:100%;}.card-front-layer{opacity:", function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? 0 : 1;
}, ";z-index:", z_index/* LAYER_ONE */.KW, ";}.card-back-layer{height:100%;position:absolute;opacity:", function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? 1 : 0;
}, ";z-index:", function(param) {
    var isFlipped = param.isFlipped;
    return isFlipped ? z_index/* LAYER_TWO */.wc : z_index/* HIDDEN */.A1;
}, ";}");

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/grid-paragraph-with-image.js + 2 modules
var grid_paragraph_with_image = __webpack_require__(32627);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card/sliding-card-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var CARD_DEFAULT_PROPS = {
    width: "100%",
    height: "100%",
    titleSize: sizes.XS,
    textSize: sizes.MD
};
var SlidingCardComponent = function(param) {
    var card = param.card, disableCardsHoverStyle = param.disableCardsHoverStyle, fullParagraphAdvancedConfig = param.fullParagraphAdvancedConfig, borderOpacity = param.borderOpacity, borderColor = param.borderColor, cardColor = param.cardColor, cardInnerPadding = param.cardInnerPadding;
    var ref = (0,react.useState)(false), isFlipped = ref[0], setIsFlipped = ref[1];
    var backLayer = card === null || card === void 0 ? void 0 : card.backLayer;
    var isBackLayerEnabled = Boolean(backLayer === null || backLayer === void 0 ? void 0 : backLayer.enable);
    var onCardHover = function() {
        isBackLayerEnabled && setIsFlipped(function(isHover) {
            return !isHover;
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSlidingCardComponent, {
        isFlipped: isFlipped,
        onMouseEnter: onCardHover,
        onMouseLeave: onCardHover,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("card", "card-front-layer"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_paragraph_with_image/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, card), {
                    disableHoverStyle: disableCardsHoverStyle,
                    fullParagraph: _object_spread({}, fullParagraphAdvancedConfig, card.fullParagraph),
                    borderOpacity: borderOpacity,
                    borderColor: borderColor,
                    cardColor: cardColor,
                    padding: cardInnerPadding
                }), CARD_DEFAULT_PROPS))
            }),
            isBackLayerEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("card", "card-back-layer"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid_paragraph_with_image/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, backLayer), {
                    disableHoverStyle: disableCardsHoverStyle,
                    fullParagraph: _object_spread({}, fullParagraphAdvancedConfig, backLayer.fullParagraph),
                    borderOpacity: borderOpacity,
                    borderColor: borderColor,
                    cardColor: cardColor,
                    padding: cardInnerPadding
                }), CARD_DEFAULT_PROPS))
            })
        ]
    });
};
/* harmony default export */ var sliding_card_component = (SlidingCardComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-base/sliding-card-grid-base-component.js
function sliding_card_grid_base_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sliding_card_grid_base_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sliding_card_grid_base_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function sliding_card_grid_base_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sliding_card_grid_base_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sliding_card_grid_base_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}












var SlidingCardGridBaseComponent = function(param) {
    var cards = param.cards, cardsToShow = param.cardsToShow, cardColor = param.cardColor, cardInnerPadding = param.cardInnerPadding, borderColor = param.borderColor, borderOpacity = param.borderOpacity, arrowsColor = param.arrowsColor, isFullScreen = param.isFullScreen, fullParagraphAdvancedConfig = param.fullParagraphAdvancedConfig, desktopHorizontalPadding = param.desktopHorizontalPadding, disableCardsHoverStyle = param.disableCardsHoverStyle, slideBreakingPoints = param.slideBreakingPoints;
    var slideResponsive = (0,react.useMemo)(function() {
        return slideBreakingPoints === null || slideBreakingPoints === void 0 ? void 0 : slideBreakingPoints.map(function(param) {
            var breakpoint = param.breakpoint, slidesToShow = param.slidesToShow;
            return {
                breakpoint: parseInt(breakpoint),
                settings: {
                    slidesToShow: parseFloat(slidesToShow)
                }
            };
        });
    }, [
        slideBreakingPoints
    ]);
    var itemRenderer = function(card) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(sliding_card_component, {
            card: card,
            disableHoverStyle: disableCardsHoverStyle,
            fullParagraphAdvancedConfig: fullParagraphAdvancedConfig,
            borderOpacity: borderOpacity,
            borderColor: borderColor,
            cardColor: cardColor,
            padding: cardInnerPadding
        });
    };
    var areCardsToShowUnevenNumber = (0,react.useMemo)(function() {
        return Number(cardsToShow) < cards.length && !Number.isInteger(Number(cardsToShow));
    }, [
        cards.length,
        cardsToShow
    ]);
    var PrevArrow = function(param) {
        var className = param.className, onClick = param.onClick;
        var onPrevArrowClick = function() {
            if (onClick) {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
                    info3: "prev"
                });
                onClick();
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: classnames_default()(className, "carousel-arrow-wrapper", "prev"),
            onClick: onPrevArrowClick,
            tabIndex: 0,
            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClick),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(prev_carousel_arrow, {
                isDisabled: !onClick,
                color: colors/* default */.Z[arrowsColor]
            })
        });
    };
    var NextArrow = function(param) {
        var className = param.className, onClick = param.onClick;
        var onNextArrowClick = function() {
            if (onClick) {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_ARROW_CLICKED, {
                    info3: "next"
                });
                onClick();
            }
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            type: "button",
            className: classnames_default()(className, "carousel-arrow-wrapper", "next"),
            onClick: onNextArrowClick,
            tabIndex: 0,
            onKeyDown: (0,accessibility_service/* generateOnKeyDownHandler */.vR)(onClick),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_carousel_arrow, {
                isDisabled: !onClick,
                color: colors/* default */.Z[arrowsColor]
            })
        });
    };
    var carouselProps = {
        items: cards,
        itemRenderer: itemRenderer,
        defaultIndex: 0,
        infinite: false,
        centerMode: false,
        slidesToShow: Number(cardsToShow) || undefined,
        centerPadding: "15%",
        arrows: true,
        swipeToSlide: true,
        prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrevArrow, {}),
        nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextArrow, {})
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSlidingCardGridBaseComponent, {
        className: classnames_default()("sliding-card-grid-component", {
            "full-carousel-width": areCardsToShowUnevenNumber,
            "full-screen": isFullScreen,
            "disable-hover-effect": disableCardsHoverStyle
        }),
        style: {
            padding: "0 ".concat(desktopHorizontalPadding)
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, sliding_card_grid_base_component_object_spread_props(sliding_card_grid_base_component_object_spread({}, carouselProps), {
            responsive: slideResponsive
        }))
    });
};
/* harmony default export */ var sliding_card_grid_base_component = (SlidingCardGridBaseComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/components/sliding-card-grid-mobile/sliding-card-grid-mobile-component.js
function sliding_card_grid_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sliding_card_grid_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sliding_card_grid_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function sliding_card_grid_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sliding_card_grid_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sliding_card_grid_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var SlidingCardGridMobileComponent = function(_param) {
    var cardsToShow = _param.cardsToShow, isFullScreen = _param.isFullScreen, rest = _object_without_properties(_param, [
        "cardsToShow",
        "isFullScreen"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(sliding_card_grid_base_component, sliding_card_grid_mobile_component_object_spread_props(sliding_card_grid_mobile_component_object_spread({}, rest), {
        isFullScreen: true,
        cardsToShow: 1.2
    }));
};
/* harmony default export */ var sliding_card_grid_mobile_component = (SlidingCardGridMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/sliding-card-grid-component.js




var SlidingCardGridComponent = (0,responsive_hoc_component/* default */.Z)(sliding_card_grid_base_component, sliding_card_grid_mobile_component);
SlidingCardGridComponent.defaultProps = default_props;
/* harmony default export */ var sliding_card_grid_component = (SlidingCardGridComponent);


/***/ })

}]);